export const isGhccMessage = (ghccMessage) => {
    return !!ghccMessage.data.Function;
};
//# sourceMappingURL=isGhccMessage.js.map